import persistState from 'redux-localstorage';
import rootReducer from './store/rootReducer';
import {applyMiddleware, compose, createStore} from "redux";
import createSagaMiddleware from 'redux-saga';
import rootSaga from "./store/rootSaga";

const sagaMiddleware = createSagaMiddleware();

const enhancer = compose(
    applyMiddleware(sagaMiddleware),
    persistState(['authorization'], {key: process.env.REACT_APP_KEY})
);

const store = createStore(rootReducer, enhancer);
sagaMiddleware.run(rootSaga);
export {store};